import { Prognosis, delay, random, randomInt } from '../utilities'
import { resolve, reject } from 'q';

export interface Student {
    id: number,
    socialSecurityNumber: number,
    name: string,
    class: string,
    school: string,
    prognosis: Prognosis
}

export default class Students {
    static async getUsers(): Promise<Student[]> {
        await delay(2000);
        return [
            { id: 1, socialSecurityNumber: 200301311234, name: "Kajsa-Maja Svensson", class: 'TE1A', school: 'Katrineholmsskolan', prognosis: 4 },
            { id: 2, socialSecurityNumber: 200204124321, name: "Kalle Kuling", class: 'TE2B', school: 'Katrineholmsskolan', prognosis: 3 },
            { id: 6, socialSecurityNumber: 200301311234, name: "Luke Skywalker", class: 'TE1A', school: 'Katrineholmsskolan', prognosis: 3 },
            { id: 3, socialSecurityNumber: 200404124321, name: "Kalle Anka", class: 'TE2B', school: 'Katrineholmsskolan', prognosis: 1 },
            { id: 4, socialSecurityNumber: 200501311234, name: "Samus Aran", class: 'TE1A', school: 'Katrineholmsskolan', prognosis: 5 },
            { id: 5, socialSecurityNumber: 200604124321, name: "Tess Tomassson", class: 'TE3B', school: 'Katrineholmsskolan', prognosis: 2 }
        ];
    };

    static async updatePrognosis(id: number, prognosis: Prognosis) {
        const ms = random(0, 5000);
        await delay(ms);

        const success = randomInt(1, 5);

        if (success != 5) {
            return resolve(true);
        }
        else {
            return reject(false);
        }
    };
}